import {
  Branch,
  CustomerData,
  CustomersResponse,
} from "@/core/customers/entities/Customers";
import // KYCStatus,
  //RiskLevel,
  // SegmentStatus
  "../entities";
import { CanalType } from "@/core/customers/entities/ProspectsTypes";
import { mapPersonType, PersonType } from "@/lib/utils";

type NullableNumericString = string | number | null | undefined;

export interface ApiReferentielCustomerItem {
  id: string;
  businessKey: string;
  full_name: string;
  branch?: Branch | null;
  advisorName?: string | null;
  type?: string | null;
  maj?: string | null;
  status?: string | null;
  riskLevel?: string | null;
  nbr_compte?: NullableNumericString;
  kyc?: string | null;
  total_balance?: NullableNumericString;
  createdTimestamp?: string | null;
  imported?: boolean;
  onboardingChannel?: CanalType | null;
}

export class CustomersListMapper {
  static toDomainItem(
    item: ApiReferentielCustomerItem,
    defaultImported: boolean
  ): CustomerData {
    const toStringSafe = (value?: NullableNumericString): string => {
      if (value === null || value === undefined) {
        return "";
      }
      return typeof value === "number" ? value.toString() : value;
    };

    return {
      id: item.id,
      businessKey: item.businessKey,
      fullName: item.full_name,
      segment: mapPersonType((item.type as PersonType) || "PERSONNE_PHYSIQUE"),
      agency: item.branch?.name ?? null,
      rm: item.advisorName ?? null,
      kycStatus: item.kyc ?? null,
      riskLevel: item.riskLevel ?? null,
      onboardingChannel: item.onboardingChannel ?? null,
      accountNumber: toStringSafe(item.nbr_compte),
      totalBalance: toStringSafe(item.total_balance),
      updatedAt: item.maj ?? "",
      createdAt: item.createdTimestamp ?? "",
      isImported: item.imported ?? defaultImported,
    };
  }

  static toDomainItems(
    response: CustomersResponse,
    defaultImported = true
  ): CustomerData[] {
    const items = response.data?.items || [];
    return items.map((it) =>
      this.toDomainItem(
        it as unknown as ApiReferentielCustomerItem,
        defaultImported
      )
    );
  }
}
